import script from "./StatisticSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./StatisticSkeleton.vue?vue&type=style&index=0&id=517353f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517353f8"]])

export default __exports__